import PropTypes from 'prop-types';

const ImageGalleryListPropType = {
  images: PropTypes.array.isRequired,
};

export default ImageGalleryListPropType;
